export default "__VITE_ASSET__MgdkQmPH__"